import { Spin, SpinProps } from 'antd'
import styled from 'styled-components'

const StyledSpin = styled(Spin)<{ $color: string }>`
  .ant-spin-dot-item {
    background-color: ${(props) => props.$color} !important;
  }
`

export const Spinner = (props: SpinProps & { color?: string }) => {
  let { color = '#ccc', size = 'default' } = props
  return <StyledSpin {...props} $color={color} size={size} />
}
